import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { EMPTY, Observable, catchError, concatMap, merge, switchMap, takeWhile, tap } from 'rxjs';
import { enablePage } from 'src/state/app-meta/app-meta.actions';
import {
  selectLoadingSpinnerStatus,
  selectNoConfigDataStatus,
  selectPageEnabledStatus
} from 'src/state/app-meta/app-meta.selectors';
import { AppState } from 'src/state/app.state';
import { environment } from '../environments/environment';
import { ConfigApiService } from './services/config-api.service';
import { RedirectionService } from './services/redirection.service';
import { SubscriptionService } from './services/subscription.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit {
  public disablePage$: Observable<boolean> = this.store.select(selectPageEnabledStatus);
  public stopSpinner$: Observable<boolean> = this.store.select(selectLoadingSpinnerStatus);
  public noConfigData$: Observable<boolean> = this.store.select(selectNoConfigDataStatus);
  public isProd: boolean = environment.production;
  isDWApp = false;
  constructor(
    private store: Store<AppState>,
    private subService: SubscriptionService,
    private configApiService: ConfigApiService,
    private redirectionService: RedirectionService,
    private router: Router
  ) {}
  hasError = false;
  ngOnInit(): void {
    this.subService
      .extractParamsFromURL()
      .pipe(
        switchMap(() => {
          console.log(this.subService.id);
          if (this.subService.id === '0000') {
            this.isDWApp = true;
            return EMPTY;
          }
          return this.redirectionService.checkUser();
        }),
        /* concatMap(() => this.redirectionService.checkUser()), */
        tap(({ isAllowedToContinue, URL }) => {
          if (!isAllowedToContinue) {
            console.log('User is not allowed to participate');
            // TODO: Check if we need to inform the user before the forwarding to the agency url
            if (URL) window.location.href = URL;
            else {
              this.store.dispatch(
                enablePage({
                  disablePage: false,
                  stopLoadingSpinner: true,
                  noConfigData: true
                })
              );
              // Avoids re-navigating to `/terminate`, which would reset existing query parameters.
              if (!this.router.url.startsWith('/terminate')) {
                this.router.navigate(['/terminate']);
              }
            }
          }
        }),
        catchError(() => {
          this.store.dispatch(
            enablePage({
              disablePage: false,
              stopLoadingSpinner: true,
              noConfigData: false
            })
          );
          this.hasError = true;
          throw Error;
        }),
        takeWhile(({ isAllowedToContinue }) => {
          return isAllowedToContinue;
        }),
        concatMap(() => {
          return merge([this.redirectionService.createUser().subscribe(), this.configApiService.fetchConfig()]);
        })
      )
      .subscribe();
  }
}
